<template>
  <div class="postModal" v-show="value">
    <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <span class="modalClose" @click="close">&#10006;</span>
          <!-- <div class="modal-header">
              <slot name="header">Header</slot>
          </div> -->
          <div class="modal-body">
              <slot name="body">
                <!-- <img :src="selectedUrl"/> -->
                <h2 class="blogTitle">{{ selectedPost.title }}</h2>
                <div class="blogDate">{{ selectedPost.date }}</div>
                <div class="blogBody" v-html="selectedPost.blogBody"></div>
              </slot>
          </div>
          <!-- <div class="modal-footer">
              <slot name="footer">Footer</slot>
          </div> -->
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'blogModal',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    selectedPost: {
      type: Object,
      required: true
    }
  },
  methods: {
    close () {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped>
.modal-container {
  height: 95vh;
  overflow: auto;
}
.modalClose {
  position: fixed;
  top: 5%;
  right: 10%;
  background-color: rgba(0,0,0,.1);
  padding: .75em 1em;
  border-radius: 50%;
  z-index: 2;
}
.modalClose:hover, .modalClose:focus {
  cursor: pointer;
  background-color: rgba(193, 241, 0,.8);
}
@media screen and (max-width: 768px) {
  .modalClose {
    font-size: .75em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogModal.vue